import ApiClient from "../ApiClient";

const GoogleMeetServices = {

    async exchangeCode(code) {
        const resp = await ApiClient.post("/GoogleMeet/oauth/token", { code });
        return resp.data.data;
    },

    async refreshToken(refreshToken) {
        const resp = await ApiClient.post("/GoogleMeet/oauth/refresh", {
            refreshToken
        });
        return resp.data.data;
    },

    async createUserMeeting(payload) {
        const auth = JSON.parse(localStorage.getItem("google_auth"));

        return ApiClient.post(
            "/GoogleMeet/user/meetings",
            payload,
            {
                headers: {
                    "Google-Token": auth.access_token
                }
            }
        ).then(r => r.data.data);
    },

    async updateUserMeeting(meetingId, payload) {
        const auth = JSON.parse(localStorage.getItem("google_auth"));

        return ApiClient.patch(
            `/GoogleMeet/user/meetings/${encodeURIComponent(meetingId)}`,
            payload,
            {
                headers: {
                    "Google-Token": auth.access_token
                }
            }
        ).then(r => r.data.data);
    },

    // (future use) Get scheduled meetings
    async getUpcomingMeetings() {
        const resp = await ApiClient.get("/GoogleMeet/meetings/upcoming");
        return resp.data.data;
    },

    async deleteMeeting(meetingId, accessToken) {
        return ApiClient.delete(`/GoogleMeet/meetings/${meetingId}`, {
            headers: {
                "Google-Token": accessToken
            }
        })
            .then(r => r.data);
    },

    async deleteExpiredMeetings(accessToken) {
        return ApiClient.delete(`/GoogleMeet/meetings`, {
            headers: {
                "Google-Token": accessToken
            }
        }).then(r => r.data);
    },

};

export default GoogleMeetServices;
